<template>
  <div class="info" >
    <div class="container-fluid ">



<!--      <div class="row col d-flex justify-content-center">
        <div class="mw-10" v-if="this.server_noti.status == 'publish'">
          <div class="card mx-auto" style="width: 30rem;">
            <div class="card-body ">
              <h5 class="card-title  text-danger">NOTIFICATION</h5>
            </div>
            <ul class="list-group list-group-flush ">
              <li class="list-group-item text-danger" v-html="this.server_noti_text"></li>
              
            </ul>
          </div>
        </div>
      </div> -->

<!--         <button @click="testline1()">TEST1</button>
       <button @click="sentline()">TEST2</button> -->
      <div class="card-group col d-flex justify-content-center" >


        <div class="mw-10">
          <div class="card" style="width: auto">
            <div class="media" style="align-items:center;display: flex;flex-wrap: wrap;">
              <span class="media-left image_section">
                <img src="../assets/bcoin-icon.webp" class="w-75">
              </span>
              <div class="media-body">
                <h3 class="media-heading" >BCOIN (THB)</h3>
<!--                 <h4><p class="card-text text-info"> ราคาปัจจุบัน</p></h4> -->
                <h2><p class="card-text text-info">{{this.price_bcoin_thb}} THB </p></h2>
                <p class="text-primary">Price Change 24 ชม. : {{ this.price_bcoin_change.toFixed(2)}} %</p>
                <p class="text-success">ราคาสูงสุด 24 ชม. : {{this.price_bcoin_thb_high}}</p>
                <p class="text-danger ">ราคาต่ำ 24 ชม. : {{this.price_bcoin_thb_low}}</p>
              </div>
            </div>
          </div>
        </div>


        <div class="mw-10">
          <div class="card" style="width: auto">
            <div class="media" style="align-items:center;display: flex;flex-wrap: wrap;">
              <span class="media-left  image_section">
                <img src="../assets/bcoin-icon.webp" class="w-75">
              </span>
              <div class="media-body">
                <h3 class="media-heading" >BCOIN (USD)</h3>
                <!-- <h4><p class="card-text text-info"> ราคาปัจจุบัน</p></h4> -->
                <h2><p class="card-text text-info">{{this.price_bcoin_usd}} USD </p></h2>
                <p class="text-primary">Price Change 24 ชม. : {{ this.price_bcoin_change.toFixed(2)}} %</p>
                <p class="text-success">ราคาสูงสุด 24 ชม. : {{this.price_bcoin_usd_high}}</p>
                <p class="text-danger ">ราคาต่ำ 24 ชม. : {{this.price_bcoin_usd_low}}</p>
              </div>
            </div>
          </div>
        </div>

<!--         <div class="mw-10">
          <div class="card" style="width: auto">
            <div class="media" style="align-items:center;display: flex;flex-wrap: wrap;">
              <span class="media-left  image_section">
                <img src="../assets/poster3.png" class="w-75">
              </span>
              <div class="media-body">
                <h3 class="media-heading" >BHERO&BHOUSE</h3>
                <h2><p class="card-text text-info">Mint</p></h2>
                <p class="text-secondary">BHERO SOLD : {{Number(this.bhero_sold).toLocaleString()}}</p>
                <p class="text-secondary">BHOUSE SOLD : {{Number(this.bhouse_sold).toLocaleString()}}/5,000</p>
                <p class="text-secondary">&nbsp;</p>
              </div>
            </div>
          </div>
        </div> -->




<!--         <div class="mw-10">
          <div class="card" style="width: 17rem;">
            <img src="../assets/bcoin-icon.webp" class="card-img-top p-5 ">
            <div class="card-body ">
              <h5 class="card-title  text-primary">Bombcrypto (THB)</h5>
              <h4><p class="card-text text-info"> ราคาปัจจุบัน</p></h4>
              <h2><p class="card-text text-info">{{this.price_bcoin_thb}} THB </p></h2>
            </div>
            <ul class="list-group list-group-flush ">
              <li class="list-group-item text-primary">Price Change 24 ชม. : {{ this.price_bcoin_change.toFixed(2)}} %</li>
              <li class="list-group-item text-success">ราคาสูงสุด 24 ชม. : {{this.price_bcoin_thb_high}}</li>
              <li class="list-group-item text-danger ">ราคาต่ำ 24 ชม. : {{this.price_bcoin_thb_low}}</li>
            </ul>
          </div>
        </div>

        <div class="mw-10">
          <div class="card mx-auto" style="width: 17rem;">
            <img src="../assets/bcoin-icon.webp" class="card-img-top  p-5">
            <div class="card-body ">
              <h5 class="card-title  text-primary">Bombcrypto (USD)</h5>
              <h4><p class="card-text text-info"> ราคาปัจจุบัน</p></h4>
              <h2><p class="card-text text-info">{{this.price_bcoin_usd}} USD </p></h2>
            </div>
            <ul class="list-group list-group-flush ">
              <li class="list-group-item text-primary">Price Change 24 ชม. : {{ this.price_bcoin_change.toFixed(2)}} %</li>
              <li class="list-group-item text-success">ราคาสูงสุด 24 ชม. : {{this.price_bcoin_usd_high}}</li>
              <li class="list-group-item text-danger">ราคาต่ำ 24 ชม. : {{this.price_bcoin_usd_low}}</li>
            </ul>
          </div>
        </div>

        <div class="mw-10">
          <div class="card mx-auto" style="width: 17rem;">
            <img src="../assets/poster3.png" class="card-img-top">
            <div class="card-body ">
              <h5 class="card-title  text-primary">BHERO & BHOUSE</h5>
              <h4><p class="card-text text-info">จำนวน ฮีโร่และบ้าน </p></h4>
              <h2><p class="card-text text-info">ที่ขายไปแล้ว !!</p></h2>

            </div>
            <ul class="list-group list-group-flush ">
              <li class="list-group-item text-secondary">BHERO SOLD : {{Number(this.bhero_sold).toLocaleString()}}</li>
              <li class="list-group-item text-secondary">BHOUSE SOLD : {{Number(this.bhouse_sold).toLocaleString()}}/5,000</li>
              <li class="list-group-item text-secondary">&nbsp;</li>
            </ul>
          </div>
        </div>
 -->




      </div>


   
   <div v-for="(items,i) in ccu" :key="i" class="row">

      <div  v-if="i == 0" class="col-xl-6 col-lg-6 mb-4" >
        
        <div class="bg-white rounded-lg p-3 shadow">
          <h2 class="h6 font-weight-bold text-center mb-4">ALL SERVER Status : {{items.status}}</h2>
          <div v-bind:class="'text-light ' + process_bg" style="height: 30px;">
            <div class="progress-bar-striped progress-bar-animated bg-warning"
            role="progressbar"
            v-bind:style="{ width: ccu_total_percent.toFixed(0) + '%' }"
            style="width: 25%"
            v-bind:aria-valuenow="ccu_total_percent.toFixed(0)"
            aria-valuemin="0"
            aria-valuemax="100"><h4>{{ ccu_total_percent.toFixed(0) }} %</h4></div>
          </div>
          <div class="row text-center mt-5">
            <div class="col-6 border-right text-right">
              <div class="h4 font-weight-bold mb-0">{{Number(items.ccu).toLocaleString()}}</div><span class="small text-gray">CURRENT</span>
            </div>
            <div class="col-6 text-left" >
              <div class="h4 font-weight-bold mb-0">{{Number(items.maxCcu).toLocaleString()}}</div><span class="small text-gray">MAX</span>
            </div> 
          </div>
        
        </div>
      </div> 




       <div  v-for="(detail,z) in items.details" :key="z" class="col-xl-3 col-lg-6 mb-4" >
        
      <!--  {{getclassprogress(ccu[1][z].percent)}} -->

        <div class="bg-white rounded-lg p-3 shadow">
          <h2 class="h6 font-weight-bold text-center mb-4">SERVER # {{detail[0]}}</h2>
      
          <div v-bind:class="(ccu[1][z].percent == '0') ? 'text-light progress bg-danger' : 'text-light progress bg-success'"  style="height: 30px">
             <div class="progress-bar-striped progress-bar-animated bg-success"
            role="progressbar"
            v-bind:style="{ width: ccu[1][z].percent + '%' }"
            v-bind:aria-valuenow="ccu[1][z].percent "
            aria-valuemin="0"
            aria-valuemax="100"><h4>{{ccu[1][z].percent}}%</h4></div> 
          </div>
          <div class="row text-center mt-5">
            <div class="col-6 border-right text-right">
              <div class="h4 font-weight-bold mb-0">{{Number(detail[1]).toLocaleString()}}</div><span class="small text-gray">CURRENT</span>
            </div>
            <div class="col-6 text-left">
              <div class="h4 font-weight-bold mb-0">{{Number(detail[2]).toLocaleString()}}</div><span class="small text-gray">MAX</span>
            </div> 
          </div>
        
        </div>
      </div> 

    </div>
  </div>
<!-- Bz2sOahALasWT8vckCkYV8Fq4xNnfRSyfO0YCaHEBwO
 -->
    
  </div>
</template>


<script>
import axios from 'axios'

export default {
  
  name: 'Info',
  data(){
    return{
      price_bcoin_usd : 0,
      price_bcoin_thb : 0,
      price_datetime_update : null,
      price_bcoin_usd_high : 0,
      price_bcoin_usd_low : 0,
      price_bcoin_thb_high : 0,
      price_bcoin_thb_low : 0,
      price_bcoin_change : 0,
      ccu : [],
      bhero_sold :0,
      bhouse_sold :0,
      server_noti : [],
      server_noti_text : '',
      process_bg : 'progress bg-success',
      ccu_percent : [],
      ccu_total_percent : 0

    }
  },
  created () {
    document.title = "BOMB INFO BY SEA";
  },
  computed:{

  },
  methods:{
      test222(){

const request = require('request')

request({
  method: 'POST',
  uri: 'https://notify-api.line.me/api/notify',
  header: {
    'Content-Type': 'application/x-www-form-urlencoded',
  },
  auth: {
    bearer: 'Bz2sOahALasWT8vckCkYV8Fq4xNnfRSyfO0YCaHEBwO', //token
  },
  form: {
    message: 'ทดสอบ', //ข้อความที่จะส่ง
  },
}, (err, httpResponse, body) => {
  if (err) {
    console.log(err)
  } else {
    console.log(body)
  }
})

  },
/*     async sentline(){

      const axios = require('axios');
      const querystring = require('querystring');

      axios({
          method: 'post',
          url: 'https://notify-api.line.me/api/notify',
          
          headers: {
            'Authorization': 'Bearer Bz2sOahALasWT8vckCkYV8Fq4xNnfRSyfO0YCaHEBwO',
            'Content-Type': 'application/x-www-form-urlencoded',
            'Access-Control-Allow-Origin': '*',
            useCredentails: true,
          },
          data: querystring.stringify({
            message: 'something you would like to push',
          })
        })
      .then( function(res) {
        console.log(res.data);
      })
      .catch( function(err) {
        console.error(err);
      }); 


const request = require('request')

request({
  method: 'POST',
  uri: 'https://notify-api.line.me/api/notify',
  header: {
    'Content-Type': 'application/x-www-form-urlencoded',
    'Access-Control-Allow-Origin': '*',
     useCredentails: true,
    
  },
  auth: {
    bearer: 'Bz2sOahALasWT8vckCkYV8Fq4xNnfRSyfO0YCaHEBwO', //token
  },
  form: {
    message: 'ทดสอบ', //ข้อความที่จะส่ง
  },
}, (err, httpResponse, body) => {
  if (err) {
    console.log(err)
  } else {
    console.log(body)
  }
})



    },
async  test() {
  const result = await axios({
    method: "post",
    url: "https://notify-api.line.me/api/notify",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
       Authorization: "Bearer Bz2sOahALasWT8vckCkYV8Fq4xNnfRSyfO0YCaHEBwO",
      'Access-Control-Allow-Origin': '*',
       useCredentails: true,

    },
    data: 'message=你好哇'
   
  })
    .then((response) => {
      console.log(response);
       console.log(result)
    })
    .catch((err) => {
      console.log(err);
    });
},
testline1(){
 fetch("https://notify-api.line.me/api/notify", {
    method: "post",
    headers: {
      Authorization: "Bearer Bz2sOahALasWT8vckCkYV8Fq4xNnfRSyfO0YCaHEBwO",
      "Content-Type": "application/x-www-form-urlencoded",
       useCredentails: true,
    }
  })
    .then(res => res.json())
    .then(response => {
      console.log(response);
    });
      
}, */

    async getPriceBCoin(){
      try {
        
        const res = await axios.get('https://api.coingecko.com/api/v3/coins/bomber-coin', {
        headers: {
               useCredentails: true,
              }
            })
        if (res)
        {
          this.price_bcoin_usd = res.data.market_data.current_price.usd
          this.price_bcoin_thb = res.data.market_data.current_price.thb
          this.price_datetime_update = res.data.market_data.last_updated
         
          this.price_bcoin_thb_high = res.data.market_data.high_24h.thb
          this.price_bcoin_usd_high = res.data.market_data.high_24h.usd

          this.price_bcoin_thb_low = res.data.market_data.low_24h.thb
          this.price_bcoin_usd_low = res.data.market_data.low_24h.usd
          
          this.price_bcoin_change =  res.data.market_data.price_change_24h
        }
      } catch (error) {
        console.error(error) 
      }
    },
    async getCCU(){
      try {
        this.ccu_percent = []
        //console.log('test')
        const res = await axios.get('https://api.bombcrypto.io/ccu', {
   headers: {
         /*  "Access-Control-Allow-Methods": "GET", */
        }
      })
        if (res)
        {
          var percent = 0
           this.ccu_percent = [];
           res.data.message.details.forEach(function (item) {
            if (Number(item[1]) == 0){
              percent = 0
            }else
            {
              percent = (Number(item[1]) * 100 / Number(item[2]));
            }
            this.ccu_percent.push({'percent' : percent})
            
          }.bind(this)); 
          var percent_total = (Number(res.data.message.ccu) * 100 / Number(res.data.message.maxCcu));
          this.ccu_total_percent = percent_total
          //console.log(this.ccu_percent)
          this.ccu = [res.data.message,this.ccu_percent]
        }
      } catch (error) {
        console.error(error) 
      }
    },
    async getbhero(){
      try {
        const res = await axios.get('https://api.bombcrypto.io/total_hero')
        if (res)
        {
          this.bhero_sold = res.data
        }
      } catch (error) {
        console.error(error) 
      }
    },
    async getbhouse(){
      try {
        const res = await axios.get('https://api.bombcrypto.io/total_house')
        if (res)
        {
          this.bhouse_sold = res.data
        }
      } catch (error) {
        console.error(error) 
      }
    },
    async getnoti(){
      try {
        this.server_noti = []
        this.server_noti_text = "";
        const res = await axios.get('https://api.bombcrypto.io/notification')
        if (res)
        {
          this.server_noti = res.data
          this.server_noti_text = res.data.content.rendered.replace(/<\/?[^>]+>/ig, " ")
        }
      } catch (error) {
        console.error(error) 
      }
    },
    runtime(){
      setInterval(() => this.getPriceBCoin(),180000) // 3 นาที
      setInterval(() => this.getCCU(),60000) // 1 นาที่
      //setInterval(() => this.getbhero(),6000000) // 100 นาที
      //setInterval(() => this.getbhouse(),6000000) // 100 นาที
      //setInterval(() => this.getnoti(),600000) // 10 นาที
    },
    
  },
  mounted(){
    this.runtime()
    this.getPriceBCoin()
    this.getCCU()
    //this.getbhero()
    //this.getbhouse()
    //this.getnoti()
   }

}




</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Prompt:wght@500;600&display=swap');

.info{
 /*  background-color: #17171a; */
  font-family: 'Prompt', sans-serif;
  padding-top: 40px;
  background: #ff7e5f;
  background: -webkit-linear-gradient(to right, #ff7e5f, #feb47b);
  background: linear-gradient(to right, #ff7e5f, #feb47b);
  min-height: 94vh;
}
.card {
   border: 1px solid black;
   padding: 20px
} 
.list-group-item{
/*   border-top: 1px solid #dc3545; */
  border-top: 1px solid black;
/*   background: #ff7e5f;
  background: -webkit-linear-gradient(to right, #ff7e5f, #feb47b);
  background: linear-gradient(to right, #ff7e5f, #feb47b); */
}
.rounded-lg {
  border-radius: 1rem;
}
.text-gray {
  color: #aaa;
}
div.h4 {
  line-height: 1rem;
}
.media-heading{
    line-height: 3.5rem;
}
.image_section img{
    display: block;
}
@media (max-width:640px){
    .image_section img:first-child{
        display:none;
    }
    p.card-text{
       font-size: 90px;
    }
}
</style>